import styled from 'styled-components';
import type { SizeType } from '../../util/types';
import { Z_INDEXES } from '../../util/vars';
import { DEFAULT_TRANSITION_FUNC } from '../../util/styled';
import { MODAL_CONTENT } from '../../util/data-id';

const WIDTH: Record<SizeType, number> = {
  xs: 300,
  sm: 400,
  md: 600,
  lg: 800,
};

const TIMES: Record<'false' | 'true', number> = {
  false: 200,
  true: 350,
};

export const ModalMaskStyled = styled('div')<{
  $alwaysOnTop: boolean,
  $overflow: 'hidden' | 'auto',
}>`
  display: flex;
  position: fixed;
  z-index: ${(props) => Z_INDEXES.max  + (props.$alwaysOnTop ? 1 : 0)};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  overflow: ${(props) => props.$overflow};
  transition: all ${TIMES.false / 2}ms ${DEFAULT_TRANSITION_FUNC};
  transition-delay: ${TIMES.false}ms;
  &[data-toggle='true'] {
    transition-duration: ${TIMES.false + TIMES.false / 4}ms;
    transition-delay: 0ms;
    opacity: 1;
    [data-id='${MODAL_CONTENT}'] {
      opacity: 1;
      transform: translateY(0);
      transition-delay: ${TIMES.true - TIMES.false}ms;
      transition-duration: ${TIMES.true}ms;    
    }  
  }    
  background-color: rgba(0, 0, 0, 0.5);
`;

export const ModalWrapperStyled = styled('div')<{
  $size: SizeType
}>`
  position: relative;
  box-sizing: border-box;
  background-color: white;
  opacity: 0;
  transition: all ${TIMES.false}ms ${DEFAULT_TRANSITION_FUNC};
  transform: translateY(100px);
  border-radius: ${(props) => props.theme.radius.default};
  box-shadow: ${(props) => props.theme.shadows.lg};
  margin: 2rem auto;
  
  width: 85%;
  max-width: ${(props) => `${WIDTH[props.$size]}px`};  
  height: min-content;
`;
